import React from "react";
import { useTranslation } from "react-i18next";

import { useTransactions } from "../../context/TransactionsContext";

const FilterBtn = () => {
  const { t } = useTranslation("filter");
  const { dispatch } = useTransactions();

  const openFilterModal = () => {
    dispatch({
      type: "MODAL",
      modals: { filterModalOpen: true, threeYearsModalOpen: false, legacyUserModalOpen: false },
    });
  };

  return (
    <button className="my-transactions__btn my-transactions__btn--filter" type="button" onClick={openFilterModal}>
      <span className="material-icons material-icons-round" role="img" aria-label={t("filter")} title={t("filter")}>
        &#xE152;
      </span>
      {t("filter")}
    </button>
  );
};

export default FilterBtn;
